import { Component } from '@angular/core';
import { IntroFiveComponent } from './intro-five.component';

@Component({
  selector: 'eid-intro-five-mobile',
  templateUrl: './intro-five.mobile.component.html',
  styleUrls: ['./intro-five.mobile.component.scss']
})
export class IntroFiveMobileComponent extends IntroFiveComponent {}
